import {Container} from 'react-bootstrap';
import {Row} from 'react-bootstrap';
import {Col} from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar'
import {FaHtml5} from 'react-icons/fa';
import {FaCss3} from 'react-icons/fa';
import {SiJavascript} from 'react-icons/si';
import {FaJava} from 'react-icons/fa';
import {FaPhp} from 'react-icons/fa';
import {SiMysql} from 'react-icons/si';
import {FaAngular} from 'react-icons/fa';
import {FaReact} from 'react-icons/fa';
import {FaPython} from 'react-icons/fa';
import {SiCplusplus} from 'react-icons/si';

function Skills(){ 
    
const iconColor = {color:"white",fontSize:"50px",paddingBottom:"10px"};

   return(
   <div className="skills-content" id="skills">
        <Container >

            <div className="about-head" id="about">
                <h2 className="skills-head">My Skills</h2>
                <hr className="about-line"/>
            </div>

  <Row className="skills-row mt-5">
      
    <Col xs={12} md={6}>
            <div className="progressbar1">

                 <FaHtml5 style={iconColor}/><ProgressBar now={60} /><br/>
                 <SiJavascript style={iconColor}/><ProgressBar  now={40} /><br/>
                <SiMysql style={iconColor}/> <ProgressBar  now={55} /><br/>
               <FaReact style={iconColor}/> <ProgressBar  now={30} /><br/>
                <FaJava style={iconColor}/> <ProgressBar  now={55} /><br/>
         
            </div>
    </Col>

    <Col xs={12} md={6}>
    <div className="progressbar2">
  <FaCss3 style={iconColor}/> <ProgressBar  now={60} /><br/>
    <FaPhp style={iconColor}/> <ProgressBar  now={45} /><br/>
  <FaAngular style={iconColor}/> <ProgressBar  now={30} /><br/>
<FaPython style={iconColor}/><ProgressBar  now={60} /><br/>
    <SiCplusplus style={iconColor}/><ProgressBar  now={40} /><br/>
         
     </div>
    </Col>

  </Row>
</Container>
  </div>
);
}

export default Skills;